const FormTextareaInput = {
  // 类型
  componentType: 'FORM_TEXTAREA_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-textarea',
    text: '多行输入',
    optionTitle: true,
    description: '用于输入多行文本，最大长度限制2000字符'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 2,
    render: {
      ide: 'FormTextareaInput',
      edit: 'FormTextareaInput',
      read: 'FormTextareaInput'
    },
    lengthLimit: 2000,
    maxLengthLimit: 2000,
    label: '多行输入',
    enableRule: false,
    placeholder: '请输入',
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcFormatValue: (value, config) => {
        let realResult = null
        try {
          if (value !== undefined && value !== null) {
            realResult = value.toString().substring(0, config.lengthLimit)
          }
        } catch (error) {
          realResult = null
        }
        return realResult
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'MAXLENGTH',
    'TEXTAREA_DEFAULT',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ]
}

export default FormTextareaInput
